import { render, staticRenderFns } from "./ScrollMotion.vue?vue&type=template&id=7c0a89a6&scoped=true"
import script from "./ScrollMotion.vue?vue&type=script&lang=js"
export * from "./ScrollMotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0a89a6",
  null
  
)

export default component.exports